import{
    CLEAR_ERROR,
    CREATE_USERS,
    GET_USERS,
    USERS_FAILD,
    USER_REQUEST,
    School_Designation,
} from "../../Constants/UserSchoolConstant";
const initialState = {
    loading: false,
    school_users: [],
};
export const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case USER_REQUEST:
          return {
            loading: true,
            school_users: [],
          };
        case GET_USERS:
          return {
            ...state,
            loading: false,
            school_users: action.payload,
          };
        case CREATE_USERS:
          return {
            ...state,
            loading: false,
            school_users: action.payload,
          };
          case School_Designation:
          return {
            ...state,
            loading: false,
            school_users: action.payload,
          };
        case USERS_FAILD:
          return {
            loading: false,
            error: action.payload,
          };
        case CLEAR_ERROR:
          return {
            ...state,
            error: null,
          };
        default:
          return state;
      }
}